import React, { useState } from "react";
import Container from "../ui/Container";
import Card from "../ui/Card";
import { ChevronDown } from "lucide-react";

function QA({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <Card className="p-0 overflow-hidden">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left"
      >
        <div className="text-sm font-semibold text-white">{q}</div>
        <ChevronDown className={`h-5 w-5 text-white/60 transition ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="px-6 pb-6 text-sm leading-6 text-white/65">
          {a}
        </div>
      )}
    </Card>
  );
}

export default function GameHostingFAQ() {
  const items = [
    {
      q: "Do you support modpacks and plugins?",
      a: "Yes. Most common modpacks and plugin setups work out of the box. If you’re doing something heavy, we can recommend RAM and CPU priority.",
    },
    {
      q: "How do backups work?",
      a: "All servers include 7 daily automatic backups plus manual backups. Restores are designed to be quick so you can recover without drama.",
    },
    {
      q: "Is CPU dedicated?",
      a: "CPU is shared fairly across the node. Allocation scales with RAM, and you can add CPU Priority if you run heavier workloads.",
    },
    {
      q: "Can I upgrade later?",
      a: "Yes — upgrades are instant and prorated. Start smaller and scale as your community grows.",
    },
    {
      q: "Do you offer DDoS protection?",
      a: "Baseline protection is included for all servers. Advanced options can be added if you need higher thresholds.",
    },
  ];

  return (
    <section className="bg-[#070A0F] py-20">
      <Container>
        <div className="mx-auto max-w-4xl text-center">
          <div className="text-xs font-semibold tracking-wider text-white/50">FAQ</div>
          <h2 className="mt-3 text-balance text-4xl font-semibold leading-[0.95] tracking-tight text-white sm:text-5xl">
            Quick answers<span className="text-cyan-300">.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-white/70 sm:text-lg">
            The most common questions we get before someone deploys.
          </p>
        </div>

        <div className="mt-14 mx-auto max-w-3xl space-y-4">
          {items.map((it) => (
            <QA key={it.q} q={it.q} a={it.a} />
          ))}
        </div>
      </Container>
    </section>
  );
}
